// extracted by mini-css-extract-plugin
module.exports = {"businessFlex":"Business_businessFlex__2r4Vd","save":"Business_save__1_zKj"};